import { createContext } from 'react'
import { useLocation } from 'react-router-dom'

// eslint-disable-next-line import/no-named-as-default
import ToggleSwitcher from 'e-submission/components/Layout/ToggleSwitcher'
import { MainHeader, Nav } from 'quick-quote/components'

import { getToggles } from '../feature-toggles'

import { isEsubmissionPath, isPortalPath, isProductSelectionPath } from './navigations/utils'

export const MainLayout = function(props) {
  const { version, onBackToHome, selectedRemoteSelling, inCall, enableMaPage } = props
  const location = useLocation()
  let templateClassName = 'product-selected'

  if (isProductSelectionPath(location.pathname)) {
    templateClassName = 'product-selection'
  } else if (isEsubmissionPath(location.pathname)) {
    templateClassName = 'e-submission-page'
  } else if (isPortalPath(location.pathname)) {
    templateClassName = 'portal'
  }

  if (getToggles().ENABLE_FNA_FLOW) {
    templateClassName = `${templateClassName} fna`
  }

  const isMaPage = enableMaPage && /\/authorize\/ma/.test(location.pathname)

  return (
    <div id="main-wrapper">
      <header id="main-header" className={`header ${templateClassName}`}>
        <MainHeader
          version={version}
          onBackToHome={onBackToHome}
          selectedRemoteSelling={selectedRemoteSelling}
          inCall={inCall}
          isMaPage={isMaPage}
        />
        <Nav location={location} pages={props.pages} />
      </header>
      <div id="main-container" className={templateClassName}>
        {props.children}
      </div>
      <ToggleSwitcher />
    </div>
  )
}
